import { AttachmentResponse, WebAssetResponse } from "@akitabox/api-client";

import { buildAssetHeader, buildAttachmentRows } from "./common";

export function imageGrid(
  attachments: AttachmentResponse[],
  asset: WebAssetResponse
) {
  return (
    <table className="ck-table-resized">
      <colgroup>
        <col style={{ width: "25%" }} />
        <col style={{ width: "25%" }} />
        <col style={{ width: "25%" }} />
        <col style={{ width: "25%" }} />
      </colgroup>
      <tbody>
        {buildAssetHeader(asset, 4)}
        {buildAttachmentRows(attachments)}
      </tbody>
    </table>
  );
}
